import React from 'react';
import { Spin } from 'antd';
import { useCollection } from 'react-firebase-hooks/firestore';
import moment from 'moment';

import Client from 'containers/app/client';
import BookingCalendar from 'components/booking-calendar';
import BookingList from 'components/booking-list';

import './style.css';

const BookingsWidget = () => {
  const ref = Client.db
    .collection('bookings')
    .where('worker', '==', Client.currentUserId());
  const [collection, loading, error] = useCollection(ref);

  if (loading) return <Spin />;
  if (error) throw new Error(error);
  if (collection.docs.length < 1) return null;

  const filtered = collection.docs.filter((doc) => {
    const { dateStart } = doc.data();
    return !moment(dateStart).isBefore(moment());
  });

  return (
    <section className="bookings-widget">
      <BookingList
        bookings={filtered}
        userKey="userId"
        header={<h2>Upcoming Shifts</h2>}
      />
      <BookingCalendar bookings={collection.docs} userKey="userId" />
    </section>
  );
};

export default BookingsWidget;
